/* Login / Register card — portal-login, self-registration with live
 * company-code lookup. Ported verbatim from templates/ELCAPP.html. */
import { useState, useEffect, C, Ic, F } from './common.js';

const Login = ({ setScreen, setUser, postLoginAction, setPostLoginAction }) => {
  const [mode, setMode] = useState('login');
  const [e, se] = useState('');
  const [p, sp] = useState('');
  const [n, sn] = useState('');
  const [co, sco] = useState('');
  const [cc, scc] = useState('');
  const [phone, sphone] = useState('');
  const [a1, sa1] = useState('');
  const [a2, sa2] = useState('');
  const [city, scity] = useState('');
  const [stp, sstp] = useState('');
  const [zipc, szip] = useState('');
  const [country, scountry] = useState('');
  const [lookup, sLookup] = useState({ status: 'idle', info: null }); // idle | active | inactive | none | checking
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  // Live debounced code lookup while typing
  useEffect(() => {
    if (mode !== 'register') return;
    const code = (cc || '').trim();
    if (!code) { sLookup({ status: 'idle', info: null }); return; }
    sLookup(prev => ({ ...prev, status: 'checking' }));
    const t = setTimeout(() => {
      fetch('/api/elcapp/public/customer-lookup?code=' + encodeURIComponent(code))
        .then(r => r.json())
        .then(d => {
          if (!d.exists) sLookup({ status: 'none', info: null });
          else if (!d.active) sLookup({ status: 'inactive', info: null });
          else sLookup({ status: 'active', info: d.info });
        })
        .catch(() => sLookup({ status: 'idle', info: null }));
    }, 300);
    return () => clearTimeout(t);
  }, [cc, mode]);

  const matched = lookup.status === 'active';

  const handleLogin = async () => {
    setErr('');
    if (!e || !p) { setErr('Email and password are required.'); return; }
    setBusy(true);
    try {
      const res = await fetch('/api/elcapp/portal-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: e, password: p })
      }).then(r => r.json());
      if (res.staff) { window.location.assign(res.redirect); return; }
      setBusy(false);
      if (res.ok) {
        setUser({ loggedIn: true, company: res.company, code: res.code, isInternal: res.is_internal || false, bookingEnabled: !!res.bookingEnabled });
        if (postLoginAction) {
          setPostLoginAction(null);
          setScreen('results');
        } else {
          setScreen('landing');
        }
      } else {
        setErr(res.error || 'Login failed. Please check your credentials.');
      }
    } catch {
      setBusy(false);
      setErr('Connection error. Please try again.');
    }
  };

  const handleRegister = async () => {
    setErr('');
    if (!n || !e || !p || !cc) { setErr('Name, email, password, and company code are required.'); return; }
    // Mirrors the server's _valid_password policy (unified 2026-08).
    if (p.length < 8 || !/[A-Z]/.test(p) || !/[a-z]/.test(p) || !/\d/.test(p)) {
      setErr('Password must be at least 8 characters, with an uppercase letter, a lowercase letter, and a number.');
      return;
    }
    if (!matched) {
      // Creating a new customer — require core address fields.
      if (!co || !a1 || !city || !country) {
        setErr('New company requires company name, address, city, and country.');
        return;
      }
    }
    setBusy(true);
    try {
      const body = matched
        ? { name: n, email: e, password: p, company_code: cc }
        : { name: n, email: e, password: p, company_code: cc,
            company_name: co, address_line_1: a1, address_line_2: a2,
            city, state_province: stp, postal_code: zipc,
            country: country.toUpperCase(), phone };
      const res = await fetch('/api/elcapp/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(r => r.json());
      setBusy(false);
      if (res.ok) { setMode('success'); }
      else { setErr(res.error || 'Registration failed.'); }
    } catch {
      setBusy(false);
      setErr('Connection error. Please try again.');
    }
  };

  if (mode === 'success') return <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div className="card" style={{ padding: 48, maxWidth: 420, textAlign: 'center' }}>
    <div style={{ width: 56, height: 56, borderRadius: '50%', background: C.green, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px' }}><Ic.Check sz={26} col="#fff" /></div>
    <h2 className="bc" style={{ fontSize: 26, fontWeight: 700, marginBottom: 12 }}>Registration Submitted!</h2>
    <p style={{ color: C.textM, fontSize: 13, lineHeight: 1.7, marginBottom: 26 }}>Your account is pending admin approval. You'll be able to sign in once approved.</p>
    <button className="btn bb" style={{ width: '100%' }} onClick={() => setMode('login')}>Go to Login</button>
  </div></div>;

  const inputStyleMono = { fontFamily: 'JetBrains Mono,monospace', letterSpacing: '.06em' };

  return <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
    <div className="card" style={{ padding: 36, width: '100%', maxWidth: mode === 'register' ? 520 : 400 }}>
      <div style={{ textAlign: 'center', marginBottom: 28 }}>
        <img src="/logos/ELC%20Logo%20Full.png" alt="Express Line Corporation" style={{ height: 48, width: 'auto', display: 'block', margin: '0 auto 14px' }} />
        <h2 className="bc" style={{ fontSize: 26, fontWeight: 700, marginBottom: 3 }}>{mode === 'login' ? 'WELCOME BACK' : 'CREATE ACCOUNT'}</h2>
        <p style={{ fontSize: 12, color: C.textM }}>ELC Air Freight Platform</p>
      </div>
      {mode === 'register' && <>
        <F label="Company Code" style={{ marginBottom: 8 }}>
          <input placeholder="Enter existing code to join, or create new" value={cc} onChange={(ev) => scc(ev.target.value.toUpperCase())} style={inputStyleMono} />
        </F>
        {lookup.status === 'active' && lookup.info && (
          <div style={{ marginBottom: 14, padding: '10px 12px', background: 'rgba(34,197,94,.08)', border: '1px solid rgba(34,197,94,.3)', borderRadius: 6, fontSize: 12, lineHeight: 1.5, color: C.text }}>
            <div style={{ fontWeight: 700, color: C.green, marginBottom: 2 }}>✓ We have your info — joining {lookup.info.company_name}</div>
            <div style={{ fontSize: 11, color: C.textM }}>{[lookup.info.address_line_1, lookup.info.city, lookup.info.country].filter(Boolean).join(', ')}</div>
          </div>
        )}
        {lookup.status === 'inactive' && (
          <div style={{ marginBottom: 14, padding: '10px 12px', background: 'rgba(217,119,6,.08)', border: '1px solid rgba(217,119,6,.3)', borderRadius: 6, fontSize: 12, color: C.text }}>
            Company found but pending activation — you can register and we'll link your account once approved.
          </div>
        )}
        {lookup.status === 'none' && (cc || '').length >= 2 && (
          <div style={{ marginBottom: 14, fontSize: 11, color: C.textM, paddingLeft: 2 }}>
            New company — please fill in the company details below.
          </div>
        )}

        {!matched && <>
          <F label="Company Name" style={{ marginBottom: 14 }}><input placeholder="Your company name" value={co} onChange={(ev) => sco(ev.target.value)} /></F>
          <F label="Address Line 1" style={{ marginBottom: 14 }}><input placeholder="Street address" value={a1} onChange={(ev) => sa1(ev.target.value)} /></F>
          <F label="Address Line 2" style={{ marginBottom: 14 }}><input placeholder="Suite, unit (optional)" value={a2} onChange={(ev) => sa2(ev.target.value)} /></F>
          <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
            <F label="City" style={{ flex: 2 }}><input value={city} onChange={(ev) => scity(ev.target.value)} /></F>
            <F label="State" style={{ flex: 1 }}><input value={stp} onChange={(ev) => sstp(ev.target.value)} /></F>
            <F label="Zip" style={{ flex: 1 }}><input value={zipc} onChange={(ev) => szip(ev.target.value)} /></F>
          </div>
          <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
            <F label="Country (ISO-2)" style={{ flex: 1 }}><input placeholder="US" value={country} onChange={(ev) => scountry(ev.target.value.toUpperCase())} style={inputStyleMono} maxLength={2} /></F>
            <F label="Phone" style={{ flex: 2 }}><input placeholder="+1 555 123 4567" value={phone} onChange={(ev) => sphone(ev.target.value)} /></F>
          </div>
        </>}

        <div style={{ height: 1, background: C.brd, margin: '4px 0 14px' }} />
        <F label="Full Name" style={{ marginBottom: 14 }}><input placeholder="Your name" value={n} onChange={(ev) => sn(ev.target.value)} /></F>
      </>}
      <F label="Email" style={{ marginBottom: 14 }}><input type="email" placeholder="you@company.com" value={e} onChange={(ev) => se(ev.target.value)} /></F>
      <F label="Password" style={{ marginBottom: err ? 10 : 22 }}><input type="password" placeholder="••••••••" value={p} onChange={(ev) => sp(ev.target.value)} onKeyDown={(ev) => ev.key === 'Enter' && (mode === 'login' ? handleLogin() : handleRegister())} /></F>
      {err && <div style={{ color: C.red, fontSize: 12, marginBottom: 14, padding: '8px 12px', background: 'rgba(220,38,38,0.06)', borderRadius: 6, lineHeight: 1.5 }}>{err}</div>}
      <button className="btn bb" style={{ width: '100%', fontSize: 14, padding: '12px', marginBottom: 10 }} disabled={busy} onClick={mode === 'login' ? handleLogin : handleRegister}>
        {busy ? '…' : mode === 'login' ? 'LOGIN' : 'REGISTER'}
      </button>
      {mode === 'login' && <div style={{ textAlign: 'center', marginBottom: 10 }}><a href="/forgot-password" style={{ fontSize: 12, color: C.textM, cursor: 'pointer', textDecoration: 'none' }}>Forgot password?</a></div>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '14px 0' }}><div style={{ flex: 1, height: 1, background: C.brd }} /><span style={{ fontSize: 11, color: C.textD }}>OR</span><div style={{ flex: 1, height: 1, background: C.brd }} /></div>
      <button className="btn bo" style={{ width: '100%', fontSize: 12 }} onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setErr(''); }}>
        {mode === 'login' ? 'Create Account' : 'Already have an account? Log In'}
      </button>
    </div>
  </div>;
};

export { Login };
